function setSubmitLoading(btn, isLoading) {
  if (!btn) return;
  if (isLoading) {
    btn.setAttribute('disabled', 'disabled');
    if (!btn.querySelector('.spinner-border-sm')) {
      const spinner = document.createElement('span');
      spinner.className = 'spinner-border spinner-border-sm inline-block mr-2 animate-spin rounded-full border-2 border-current border-t-transparent w-4 h-4';
      spinner.style.verticalAlign = 'middle';
      spinner.style.marginRight = '8px';
      btn.prepend(spinner);
    }
  } else {
    btn.removeAttribute('disabled');
    const spinner = btn.querySelector('.spinner-border-sm');
    if (spinner) spinner.remove();
  }
}

function setup_payment() {
  console.log('I18n.locale <<<<', window.I18n.locale)
  if (window.fbq) {
    window.fbq('track', 'InitiateCheckout');
  }

  // Ensure Stripe is correctly initialized on page transitions (highly robust against Turbo page changes)
  const stripeKey = document.body.getAttribute('data-stripe-publishable-key');
  if (stripeKey && window.Stripe) {
    window.stripe = window.Stripe(stripeKey);
  }

  if (!window.stripe) {
    console.error("Stripe is not initialized or window.stripe is undefined.");
    return;
  }

  // Clean up any previously mounted Stripe Elements to prevent duplicate mount errors on Turbo transitions
  if (window.stripeCardNumber) {
    try { window.stripeCardNumber.destroy(); } catch (e) { console.log(e); }
  }
  if (window.stripeCardExpiry) {
    try { window.stripeCardExpiry.destroy(); } catch (e) { console.log(e); }
  }
  if (window.stripeCardCvc) {
    try { window.stripeCardCvc.destroy(); } catch (e) { console.log(e); }
  }

  /***** Transform card into Stripe object */
  var style = {
    base: {
      color: '#fafafa',
      fontFamily: 'Roboto, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
      fontSize: '15px',
      '::placeholder': {
        color: '#71717a'
      }
    },
    invalid: {
      color: '#ef4444'
    }
  }

  var elements = stripe.elements();
  var cardNumber = elements.create('cardNumber', { style: style });
  var cardExpiry = elements.create('cardExpiry', { style: style });
  var cardCvc = elements.create('cardCvc', { style: style });

  // Store element instances globally so they can be cleaned up on the next page transition
  window.stripeCardNumber = cardNumber;
  window.stripeCardExpiry = cardExpiry;
  window.stripeCardCvc = cardCvc;

  cardNumber.mount("#card_number")
  cardExpiry.mount("#card_expiry")
  cardCvc.mount("#card_cvc")

  /* Credit Card identification */
  cardNumber.on("change", (ev) => {
    document.querySelectorAll('.brand').forEach(el => el.style.display = 'none');
    if (ev.brand) {
      const brandEl = document.querySelector('.' + ev.brand);
      if (brandEl) {
        brandEl.style.display = 'block';
      }
    }
  });

  document.querySelectorAll('.select-plan-stripe').forEach(el => {
    el.addEventListener('click', (e) => {
      const planIdEl = document.getElementById('plan_id');
      if (planIdEl) {
        planIdEl.value = e.target.getAttribute('data-plan');
      }
    });
  });

  document.querySelectorAll('.select-plan-paypal').forEach(el => {
    el.addEventListener('click', (e) => {
      const paypalBtnsEl = document.getElementById('paypal-buttons');
      if (paypalBtnsEl) {
        paypalBtnsEl.innerHTML = "";
      }
      
      if (window.paypal) {
        window.paypal.Buttons({
          createSubscription: function(data, actions) {
            return actions.subscription.create({
              'plan_id': e.target.getAttribute('data-plan'),
              'application_context' : { 
                'shipping_preference': 'NO_SHIPPING'
              }
            });
          },
          onApprove: function(data, actions) {
            console.log(data);

            const leadTokenEl = document.getElementById("lead_user_token");
            const leadToken = leadTokenEl ? leadTokenEl.value : "";
            const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

            fetch(`/${window.I18n.locale}/payment/paypal/create`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken
              },
              body: JSON.stringify({
                lead_user_token: leadToken,
                paypal_id: data.subscriptionID
              })
            });
          }
        }).render('#paypal-buttons');
      }
    });
  });

  const form = document.getElementById('payment-form');
  if (form) {
    form.addEventListener('submit', function(ev) {
      ev.preventDefault();

      const submit = document.getElementById('stripe-submit');
      if (submit) {
        setSubmitLoading(submit, true);
      }

      stripe.createPaymentMethod({
        type: 'card',
        card: cardNumber
      }).then(stripePaymentMethodHandler);
    });
  }

  function stripePaymentMethodHandler(result) {
    const submit = document.getElementById('stripe-submit');
    console.log('stripePaymentMethodHandler', result)

    if (result.error) {
      if (window.toastr) {
        window.toastr.error(result.error.message, "Payment Error", { timeOut: 0 });
      } else {
        alert(result.error.message);
      }
      if (submit) {
        setSubmitLoading(submit, false);
      }
    } else {
      const leadToken = document.getElementById("lead_user_token")?.value || "";
      const planId = document.getElementById("plan_id")?.value || "";
      const couponCode = document.getElementById("coupon_code")?.value || "";
      const email = document.getElementById("email")?.value || "";
      const campaign = document.getElementById("campaign")?.value || "";
      const abTest = document.getElementById("ab_test_name")?.value || "";
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

      fetch(`/${window.I18n.locale}/payment/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({
          lead_user_token: leadToken,
          plan_id: planId,
          coupon_code: couponCode,
          email: email,
          campaign: campaign,
          pm_id: result.paymentMethod.id,
          ab_test: abTest
        })
      })
      .then(res => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === 'ok') {
          if (window.gtag_report_conversion) {
            window.gtag_report_conversion(data.value, data.currency, data.invoice_id);
          }
          if (window.fbq) {
            window.fbq('track', 'Purchase', { currency: data.currency, value: data.value });
          }
          window.location = data.redirect;
        } else if (data && typeof data.payment_intent !== 'undefined') {
          const { client_secret, status } = data.payment_intent;

          if (status === 'requires_action') {
            stripe.confirmCardPayment(client_secret).then(function(result) {
              if (result.error) {
                if (window.toastr) {
                  window.toastr.error(result.error.message, "Authentication Error", { timeOut: 0 });
                } else {
                  alert(result.error.message);
                }
                if (submit) {
                  setSubmitLoading(submit, false);
                }
              } else {
                fetch(`/${window.I18n.locale}/payment/finish`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken
                  },
                  body: JSON.stringify({
                    lead_user_token: leadToken,
                    plan_id: planId
                  })
                })
                .then(res => res.json())
                .then((finishData) => {
                  if (window.gtag_report_conversion) {
                    window.gtag_report_conversion(finishData.payment_intent.amount / 100, finishData.payment_intent.currency, finishData.payment_intent.id);
                  }
                  if (window.fbq) {
                    window.fbq('track', 'Purchase', { currency: finishData.payment_intent.currency, value: finishData.payment_intent.amount / 100 });
                  }
                  if (submit) {
                    setSubmitLoading(submit, false);
                  }
                });
              }
            });
          } else {
            if (window.toastr) {
              window.toastr.error("We are sorry, there was an error processing your payment. Please try again with a different card.", "Payment Error", { timeOut: 0 });
            } else {
              alert("We are sorry, there was an error processing your payment. Please try again with a different card.");
            }
            if (submit) {
              setSubmitLoading(submit, false);
            }
          }
        } else if (data && data.pending_setup_intent) {
          const { client_secret, status } = data.pending_setup_intent;

          if (status === "requires_action") {
            stripe.confirmCardSetup(client_secret).then(function(result) {
              if (result.error) {
                if (window.toastr) {
                  window.toastr.error(result.error.message, "Authentication Error", { timeOut: 0 });
                } else {
                  alert(result.error.message);
                }
                if (submit) {
                  setSubmitLoading(submit, false);
                }
              } else {
                fetch(`/${window.I18n.locale}/payment/finish`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken
                  },
                  body: JSON.stringify({
                    lead_user_token: leadToken,
                    plan_id: planId
                  })
                })
                .then(res => res.json())
                .then(() => {
                  if (window.gtag_report_conversion) {
                    window.gtag_report_conversion(0, (window.I18n.locale === "pt" ? "BRL" : "USD"), client_secret);
                  }
                  if (window.fbq) {
                    window.fbq('track', 'Purchase', { currency: (window.I18n.locale === "pt" ? "BRL" : "USD"), value: 0 });
                  }
                  if (submit) {
                    setSubmitLoading(submit, false);
                  }
                });
              }
            });
          } else if (status === "requires_payment_method") {
            if (window.toastr) {
              window.toastr.error("We are sorry, there was an error processing your payment. Please try again with a different card.", "Payment Error", { timeOut: 0 });
            } else {
              alert("We are sorry, there was an error processing your payment. Please try again with a different card.");
            }
            if (submit) {
              setSubmitLoading(submit, false);
            }
          }
        } else if (data.redirect) {
          console.log(data.redirect);
          if (data.message) {
            console.log(data.message);
            if (window.toastr) {
              window.toastr.error(data.message, "Error", { timeOut: 0 });
            } else {
              alert(data.message);
            }
          }
        } else if (data.message) {
          if (window.toastr) {
            window.toastr.error(data.message, "Error", { timeOut: 0 });
          } else {
            alert(data.message);
          }
          if (submit) {
            setSubmitLoading(submit, false);
          }
        } else {
          if (submit) {
            setSubmitLoading(submit, false);
          }
        }
      })
      .catch((err) => {
        console.error('Error creating subscription:', err);
        if (submit) {
          setSubmitLoading(submit, false);
        }
      });
    }
  }
}

document.addEventListener("turbo:load", () => {
  if (document.querySelector("form#payment-form")) {
    if (window.I18n) {
      window.I18n.locale = document.body.getAttribute('data-locale') || "en";
    }
    setup_payment();
  }
});
